import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import * as Sentry from '@sentry/react';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@govbr-ds/core/dist/core.min.css';
import { environment } from './environments/environment';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'hooks/useAuth';

const APP_SYSTEM_PATH = '/dief';

const GOOGLE_ANALYTICS_IDS: Record<string, string> = {
  pro: 'G-YB0N46RW1B',
  hom: 'G-DK7KQW3HMF',
};

const loadGoogleAnalytics = (): void => {
  const analyticsId = GOOGLE_ANALYTICS_IDS[environment.environment];
  if (!analyticsId) return;

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
  document.head.appendChild(gtagScript);

  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${analyticsId}');
  `;
  document.head.appendChild(inlineScript);
};

loadGoogleAnalytics();

Sentry.init({
  dsn: 'https://68a328aadedb47b8819f86ab6e31167f@sentry.aic.serpro.gov.br/519',
  environment: environment.environment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter basename={APP_SYSTEM_PATH}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();
